module.exports = __webpack_public_path__ + "img/CCLF_infographic-06.6c030c6f.png";